import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';

export const FETCH_CATEGORIES = 'state.actions.fetch-categories.FETCH_CATEGORIES' as const;

export type FetchCategoriesPayload = {
	analyticsEvent: UIAnalyticsEvent;
};
export type FetchCategoriesAction = {
	type: typeof FETCH_CATEGORIES;
	payload: FetchCategoriesPayload;
};

export const fetchCategories = (payload: FetchCategoriesPayload): FetchCategoriesAction => ({
	type: FETCH_CATEGORIES,
	payload,
});
